import {useEffect, useMemo, useRef} from "react";

import {useGetHomematchPreleadsQuery} from "../../homematch_tinder/api/get_homematch_preleads";
import {HomematchPreleadStatus, IHomematchPreleadListItem} from "../../homematch_tinder/types/IHomematchPrelead";

interface IPersonalizedHomematchRecommendationsResult {
    /** Swipeable (pending) preleads from the user's Homematch buffer, newest first as served. */
    preleads: IHomematchPreleadListItem[];
    isLoading: boolean;
}

/**
 * The tinder buffer feeds the "Mieszkania wybrane dla Ciebie" teaser.
 * A cold-start 503 carries `Retry-After` — the buffer is being filled by a
 * background job, so the hook refetches once after that delay. Every other
 * failure (including the per-site kill switch) quietly yields an empty list
 * and the teaser falls back to browsing history.
 */
export const usePersonalizedHomematchRecommendations = (): IPersonalizedHomematchRecommendationsResult => {
    const {data, isLoading, refetch} = useGetHomematchPreleadsQuery();
    const hasRetriedRef = useRef(false);
    const retryAfterSeconds = data?.retryAfterSeconds ?? null;

    useEffect(() => {
        if (retryAfterSeconds === null || hasRetriedRef.current) {
            return;
        }

        hasRetriedRef.current = true;
        const timeoutId = window.setTimeout(() => {
            refetch();
        }, retryAfterSeconds * 1000);

        return () => {
            window.clearTimeout(timeoutId);
        };
    }, [retryAfterSeconds, refetch]);

    const preleads = useMemo(() => (data?.response?.results ?? []).filter((prelead) => prelead.status === HomematchPreleadStatus.PENDING), [data]);

    return {
        preleads,
        isLoading: isLoading || retryAfterSeconds !== null
    };
};
import {useEffect, useMemo, useRef} from "react";

import {useGetHomematchPreleadsQuery} from "../../homematch_tinder/api/get_homematch_preleads";
import {HomematchPreleadStatus, IHomematchPreleadListItem} from "../../homematch_tinder/types/IHomematchPrelead";

interface IPersonalizedHomematchRecommendationsResult {
    /** Swipeable (pending) preleads from the user's Homematch buffer, newest first as served. */
    preleads: IHomematchPreleadListItem[];
    isLoading: boolean;
}

/**
 * The tinder buffer feeds the "Mieszkania wybrane dla Ciebie" teaser.
 * A cold-start 503 carries `Retry-After` — the buffer is being filled by a
 * background job, so the hook refetches once after that delay. Every other
 * failure (including the per-site kill switch) quietly yields an empty list
 * and the teaser falls back to browsing history.
 */
export const usePersonalizedHomematchRecommendations = (): IPersonalizedHomematchRecommendationsResult => {
    const {data, isLoading, refetch} = useGetHomematchPreleadsQuery();
    const hasRetriedRef = useRef(false);
    const retryAfterSeconds = data?.retryAfterSeconds ?? null;

    useEffect(() => {
        if (retryAfterSeconds === null || hasRetriedRef.current) {
            return;
        }

        hasRetriedRef.current = true;
        const timeoutId = window.setTimeout(() => {
            refetch();
        }, retryAfterSeconds * 1000);

        return () => {
            window.clearTimeout(timeoutId);
        };
    }, [retryAfterSeconds, refetch]);

    const preleads = useMemo(() => (data?.response?.results ?? []).filter((prelead) => prelead.status === HomematchPreleadStatus.PENDING), [data]);

    return {
        preleads,
        isLoading: isLoading || retryAfterSeconds !== null
    };
};
